<section class="atrium-payment-section">
  <div class="atrium-content" *ngIf="paymentStore.verificationCustomer">
    <div *ngIf="atriumInfo.token; then atriumUserInfo else connectAtrium"></div>
    <ng-template #atriumUserInfo>
      <div class="atrium-balance-wrap">
        <ion-label color="main-dark" class="save-card__checkbox-text">
          Your Atrium Balance: ${{getFormattedPrice(atriumInfo.balance /100)}}
        </ion-label>
        <div *ngIf="isSpinner; then spinner else button"></div>
        <ng-template #button>
          <button class="ikon-apply" (click)="removeAtriumInfo()">
            Remove
          </button>
          <button *ngIf="lowBalance && atriumInfo.balance !== 0" class="ikon-apply" (click)="isPartialPayment()">
            {{isPartial ? 'Cancel' : 'Partial payment'}}
          </button>
        </ng-template>
        <ng-template #spinner>
          <div class="spinner-wrapper">
            <app-spinner></app-spinner>
          </div>
        </ng-template>
      </div>
      <div class="error-panel" *ngIf="lowBalance && atriumInfo.balance !== 0">
        Your Atrium balance doesn’t have enough funds to complete this payment. <br>
        Please enter your card number or use a saved card to make a partial payment, or choose another payment method.
      </div>
      <div class="error-panel" *ngIf="atriumInfo.balance === 0">
        Your Atrium balance is $0 and cannot be used to complete this payment. <br>
        Please select another payment method.
      </div>
    </ng-template>
    <ng-template #connectAtrium>
      <div class="atrium-title">
        Enter your Atrium Campus ID
      </div>
      <div class="manual-connect-wrap">
        <input type="text"
               [(ngModel)]="atriumCampusId"
               [ngModelOptions]="{standalone: true}"
               name="atriumCampusId"
               id="atriumCampusId"
               placeholder="Enter your Atrium Campus ID"
               class="campus-id-input" />
        <div *ngIf="isSpinner; then spinner else button"></div>
        <ng-template #button>
          <button class="ikon-apply" [disabled]="isConnecting"
                  [class.disabled]="isConnecting || !atriumCampusId"
                  (click)="saveAtriumInfo(atriumCampusId)">
            Add
          </button>
        </ng-template>
        <ng-template #spinner>
          <div class="spinner-wrapper">
            <app-spinner></app-spinner>
          </div>
        </ng-template>
      </div>
      <div *ngIf="restaurant.atriumConnectUrl" class="walletbox-text__wrapper">
        <div class="walletbox-text__border"></div>
        <span class="walletbox-text__text">or</span>
        <div class="walletbox-text__border"></div>
      </div>
      <div class="connect-wrap">
        <div *ngIf="isConnecting; then connecting else connectForm"></div>
        <ng-template #connectForm>
          <button *ngIf="restaurant.atriumConnectUrl"
                  [class.atrium-login-disabled]="!paymentStore.customer?.orderBotUserId"
                  [disabled]="!paymentStore.customer?.orderBotUserId"
                  class="connect-campus-btn" (click)="connectAtriumAccount()">
            Authorise with Atrium
          </button>
        </ng-template>
        <ng-template #connecting>
          <div class="pending-wrap">
            <div class="connect-text">
              Please finish authorization in separate window
            </div>
            <button class="ikon-apply" (click)="cancelConnect()">
              Cancel
            </button>
          </div>
        </ng-template>
      </div>

    </ng-template>
  </div>
  <div class="info-panel" *ngIf="!paymentStore.verificationCustomer">
    To start using Atrium, please enter your phone number in the "Order Status Notifications" section and verify it to proceed.
  </div>
</section>
